import { Card, Form, Col} from '@deere/ux.uxframe-react'
import React from 'react'
import { useTranslation } from "react-i18next";
import { ProgressIndicator } from '../ProgressIndicator'
import { useUserInfo } from '../../providers/userProvider';
import { CRS_REQUEST_STATUS_OBJ, SCBM_USER_TYPE, EM_ADMIN, EM_IF_ADMIN} from '../../utils/surveyLiterals'

export default function UploadEMRTCard({ loadingBar, upload, loading, fielKey,status}) {
    const { t } = useTranslation();
    const userInfo = useUserInfo();

    const isCompleted = () =>{ 
        return status === CRS_REQUEST_STATUS_OBJ.COMPLETE ? true : false;
    }

    const isGeneralUser = () =>{ 
        return userInfo.userType === SCBM_USER_TYPE.SALARY && !userInfo.roles.includes(EM_ADMIN) && !userInfo.roles.includes(EM_IF_ADMIN);
    }
    
    return (<div>
        <Card>
            <Card.Body>
                <Card.Title className='pb-3 font-weight-bold'>
                    3. {t('em_lbl_upload_template')}
                </Card.Title>
                <Form.Label>{t('em_lbl_upload_note')}</Form.Label>
                <Form.Row className="d-block mb-4">
                    <Col>
                        <Form.Group>
                            <Form.Control key={fielKey} type="file" id="emrt-template" onChange={(event) => { upload(event.target.files) }} disabled={loading || isCompleted() || isGeneralUser()} />
                        </Form.Group>
                    </Col>
                    {loadingBar ? <ProgressIndicator /> : null}
                </Form.Row>                
            </Card.Body>
        </Card>
    </div>);
}
